import { BLACK_500, BLACK_900, BLUE_GREY_100, BLUE_GREY_200, BLUE_GREY_300, BLACK_600, LILAC_200, LILAC_300, LILAC_900, checkIsPlatform, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
var DIMENTIONS_SIZE = {
  desktop: 56,
  mobile: 40
};
var THEMES_CONFIG = {
  white: {
    imageIconColor: BLACK_900,
    descriptionColor: BLACK_600,
    prefixPostfixTitleColor: BLACK_900,
    containerBackgroundColor: BLUE_GREY_100,
    containerBorderColor: BLUE_GREY_300,
    imageIconBgColor: BLUE_GREY_200
  },
  dark: {
    imageIconColor: LILAC_900,
    descriptionColor: BLACK_500,
    prefixPostfixTitleColor: BLACK_900,
    containerBackgroundColor: LILAC_200,
    containerBorderColor: LILAC_900,
    imageIconBgColor: LILAC_300
  },
  light: {
    imageIconColor: LILAC_900,
    descriptionColor: BLACK_500,
    prefixPostfixTitleColor: BLACK_900,
    containerBackgroundColor: LILAC_200,
    containerBorderColor: LILAC_900,
    imageIconBgColor: LILAC_300
  }
};
export var getUploadContainerUIProp = (isLargeScreen, theme) => {
  var height = isLargeScreen ? DIMENTIONS_SIZE.desktop : DIMENTIONS_SIZE.mobile;
  var width = isLargeScreen ? DIMENTIONS_SIZE.desktop : DIMENTIONS_SIZE.mobile;
  var _THEMES_CONFIG$theme = THEMES_CONFIG[theme],
    imageIconColor = _THEMES_CONFIG$theme.imageIconColor,
    descriptionColor = _THEMES_CONFIG$theme.descriptionColor,
    prefixPostfixTitleColor = _THEMES_CONFIG$theme.prefixPostfixTitleColor;
  return {
    addImageIcon: {
      color: imageIconColor,
      fontSize: isLargeScreen ? 32 : 24
    },
    uploadedImage: {
      source: {
        height,
        width
      }
    },
    titlePrefixPostfix: {
      color: prefixPostfixTitleColor,
      type: "body-single-line-" + (isLargeScreen ? 'md' : 'sm') + "-bold"
    },
    uploadCta: {
      buttonType: 'tertiary',
      size: isLargeScreen ? 'md' : 'sm'
    },
    description: {
      color: descriptionColor,
      type: "body-para-" + (isLargeScreen ? 'sm' : 'xs')
    }
  };
};
export var getUploadContainerStyles = (isLargeScreen, props, theme) => {
  var isVerticalContainer = props.isVerticalContainer,
    _props$uploadContaine = props.uploadContainerAlignment,
    uploadContainerAlignment = _props$uploadContaine === void 0 ? 'center' : _props$uploadContaine;
  var spacing = tokens.spacing,
    borderRadius = tokens.borderRadius;
  var height = isLargeScreen ? DIMENTIONS_SIZE.desktop : DIMENTIONS_SIZE.mobile;
  var width = isLargeScreen ? DIMENTIONS_SIZE.desktop : DIMENTIONS_SIZE.mobile;
  var _THEMES_CONFIG$theme2 = THEMES_CONFIG[theme],
    containerBackgroundColor = _THEMES_CONFIG$theme2.containerBackgroundColor,
    containerBorderColor = _THEMES_CONFIG$theme2.containerBorderColor,
    imageIconBgColor = _THEMES_CONFIG$theme2.imageIconBgColor;
  return StyleSheet.create({
    textDescContainer: {
      paddingLeft: tokens.spacing.SPACING_12
    },
    container: {
      alignItems: 'center',
      backgroundColor: containerBackgroundColor,
      borderRadius: borderRadius.BORDER_RADIUS_8,
      borderStyle: 'dashed',
      borderWidth: 1,
      borderColor: containerBorderColor,
      padding: isLargeScreen ? spacing.SPACING_16 : spacing.SPACING_20,
      flexDirection: isVerticalContainer ? 'column' : 'row',
      justifyContent: uploadContainerAlignment === 'center' ? 'center' : 'flex-start'
    },
    addImageIcon: {
      flexShrink: 0,
      backgroundColor: imageIconBgColor,
      padding: isLargeScreen ? tokens.spacing.SPACING_12 : tokens.spacing.SPACING_8,
      height,
      width,
      borderRadius: borderRadius.BORDER_RADIUS_8
    },
    textContainer: Object.assign({
      flexDirection: 'row',
      marginTop: spacing.SPACING_10
    }, isVerticalContainer && {
      alignSelf: 'center'
    }),
    uploadCta: Object.assign(Object.assign({}, checkIsPlatform('web') && {
      cursor: 'pointer'
    }), {
      alignSelf: 'center'
    }),
    description: Object.assign({
      marginTop: spacing.SPACING_4
    }, isVerticalContainer && {
      alignSelf: 'center',
      textAlign: 'center'
    }),
    title: {
      marginBottom: spacing.SPACING_4
    }
  });
};